export default {
  questions: [],
  tests: [],
  packages: [],
  banners: [],
  categories: [],
}
